import { useDispatch } from 'react-redux';
import { flatten } from 'lodash';
import { AnyObject } from 'interfaces';

const getWindowDimensions = () => {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

const getNonAccentedString = (accentedString: string): string => {
  return accentedString
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd');
};

const randomStr = (len: number, charSet: any): string => {
  charSet =
    charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';
  for (let i = 0; i < len; i++) {
    let randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }
  return randomString;
};

const normalize = (str: string) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const filterOptionSelect = (input: string, option: any) =>
  option.children
    ? normalize(option.children)
        .toLowerCase()
        .indexOf(normalize(input).toLowerCase()) >= 0
    : false;

export const formatCurrency = (value?: number) => {
  if (value || (value && value === 0))
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  else return 0;
};

const isScrollEnded = (event: React.UIEvent<HTMLDivElement>) => {
  const { scrollTop, offsetHeight, scrollHeight }: any = event.target;
  return Math.abs(scrollTop + offsetHeight - scrollHeight) <= 1;
};

const getNextPage = (
  page: number,
  pageSize: number,
  total?: number
): number | null => {
  if (typeof total === 'number' && page * pageSize >= total) return null;
  return page + 1;
};

// check value not in: [], undefined, null, ''
const hasValue = (value: any) => {
  return !!flatten([value]).join();
};

const countFilter = (filters?: AnyObject) => {
  return filters
    ? Object.values(filters).filter(item => String(item) === '0' || !!item)
        .length
    : 0;
};

/**
 * Check if visible
 * @param status true or false.
 * @return {undefined} if visible.
 * @return {[]} if invisible.
 */
function isVisible(status: boolean) {
  if (status) {
    return undefined;
  } else {
    return [];
  }
}

/**
 * Check if column with title is visible (is ticked in Display Options Modal)
 * @param title title of column.
 * @param displayOptions display options status
 */
export function isVisibleColumn(
  title: string,
  displayOptions: { [key: string]: { value: string; isChecked: boolean } }
) {
  if (displayOptions[title].isChecked) {
    return isVisible(true);
  } else {
    return isVisible(false);
  }
}

export default {
  getWindowDimensions,
  getNonAccentedString,
  randomStr,
  filterOptionSelect,
  isScrollEnded,
  getNextPage,
  hasValue,
  countFilter,
  isVisibleColumn,
};

export const useThunkDispatch = () => useDispatch();
